export class PersonFormatter {
  /**
   * Formats practitioner information with optional AGB code
   * @param name - The practitioner's name
   * @param agbCode - The practitioner's AGB code (optional)
   * @returns Formatted practitioner string with AGB code if provided
   */
  public static formatPractitioner(
    name: string | null | undefined,
    agbCode: string | null | undefined,
  ): string {
    const practitionerName = name || "Onbekend";

    return agbCode ? `${practitionerName} (AGB ${agbCode})` : practitionerName;
  }
}
